import React, { useEffect, useState, useCallback } from "react";
import { Paper, Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import qs from "qs";
import { ClientFilterProvider } from "../../hooks/ClientFilterProvider";
import EmailForm from "../../components/email/EmailForm";
import EmailResultsTable from "../../components/email/EmailResultsTable";
import ClientTableAccordion from "../../components/client/ClientTableAccordion";
import { 
  RootContainer, 
  TabContainer, 
  ContentContainer, 
  EmailFormContainer, 
  ResultsContainer 
} from "./styles/EmailStyles";

const EMAIL_TAB = "email";
const RESULTS_TAB = "results";

export const Email: React.FC = () => {
  const [activeTab, setActiveTab] = useState(EMAIL_TAB);
  const location = useLocation();
  const navigate = useNavigate();

  const updateTabInUrl = useCallback((value: string) => {
    navigate({ search: qs.stringify({ tab: value }) }, { replace: true });
  }, [navigate]);

  useEffect(() => {
    const tabFromUrl = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    }).tab as string;

    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  const handleTabChange = useCallback((_: React.ChangeEvent<{}>, value: string) => {
    updateTabInUrl(value);
  }, [updateTabInUrl]);

  const renderContent = () => {
    if (activeTab === EMAIL_TAB) {
      return (
        <EmailFormContainer>
          <ClientTableAccordion />
          <EmailForm />
        </EmailFormContainer>
      );
    }
    
    return (
      <ResultsContainer>
        <EmailResultsTable />
      </ResultsContainer>
    );
  };

  return (
    <ClientFilterProvider>
      <RootContainer
        container
        alignItems="stretch"
        justifyContent="center"
        direction="column"
        spacing={0}
      >
        <TabContainer size="grow">
          <Paper>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="email tabs"
            >
              <Tab value={EMAIL_TAB} label="Naujas laiškas" />
              <Tab value={RESULTS_TAB} label="Išsiųsti laiškai" />
            </Tabs>
          </Paper>
        </TabContainer>

        <ContentContainer size="grow">
          {renderContent()}
        </ContentContainer>
      </RootContainer>
    </ClientFilterProvider>
  );
};
